export default __webpack_public_path__ + "static/media/question.8f88c95f.svg";